<div class="m-3">
  <div class="bg-white p-4 rounded shadow-lg" style="position: relative; border-radius: 14px">
    <button
      type="button"
      class="close"
      aria-label="Close"
      style="position: absolute; top: 1rem; right: 1.25rem; opacity: 0.5"
      (click)="bsModalRef.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="text-center">
      <div
        class="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
        style="width: 64px; height: 64px; background-color: #fdecea"
      >
        <i
          class="fa fa-exclamation-triangle text-danger"
          style="font-size: 1.75rem"
          aria-hidden="true"
        ></i>
      </div>
      <h4 class="modal-title text-danger mb-2" translate>{{ title }}</h4>
      <p class="text-muted mb-0" translate>{{ message }}</p>
    </div>
  </div>
</div>
<div class="text-right p-3">
  <button type="button" class="btn btn-light mr-2" (click)="cancelDelete()">Cancel</button>
  <button type="button" class="btn btn-danger" (click)="deleteConfirmation()">Delete</button>
</div>
